import { Main, PageHeader } from '../components/PageHeader.js';

/** Watchlist / Alerts (wireframe §8–9) arrive with planner 3.1; one sentence until then. */
export function Placeholder({ title }: { title: 'Watchlist' | 'Alerts' }) {
  return (
    <Main>
      <PageHeader
        title={title}
        line={
          title === 'Watchlist'
            ? 'Watching companies for changes arrives with planner item 3.1; until then, re-verify from a profile to get a fresh record.'
            : 'Alerts on watched companies arrive with planner item 3.1; nothing is watched yet.'
        }
      />
    </Main>
  );
}
